import React from 'react';
import { IStore } from 'Store/.';
import { compose } from 'recompose';
import { connect } from 'react-redux';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { Dispatch, bindActionCreators } from 'redux';
import { getCustomerServiceContent } from 'Components/InfoCustomerService/Redux/selectors';
import { fetchCustomerServiceContent } from 'Components/InfoCustomerService/Redux/thunks';
import InfoCustomerService from 'Components/InfoCustomerService/InfoCustomerService';

interface IPropsInternal {
  content: Julius.Website.ServicePageViewModel;
  fetchCustomerServiceContent: () => void;
}

type Props = IPropsInternal;

class InfoCustomerServiceContainer extends React.PureComponent<Props> {

  componentDidMount() {
    this.props.fetchCustomerServiceContent();
  }

  render() {
    return <InfoCustomerService content={ this.props.content } />;
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    content: getCustomerServiceContent(state),
  };
};

const mapDispatchToProps = (dispatch: Dispatch) => {
  return bindActionCreators({
    fetchCustomerServiceContent,
  }, dispatch);
};

export default compose<{}, {}>(
  withRouter,
  injectIntl,
  connect(mapStateToProps, mapDispatchToProps),
)(InfoCustomerServiceContainer);


// WEBPACK FOOTER //
// ./src/components/InfoCustomerService/InfoCustomerServiceContainer.tsx